import apiClient from '../utils/apiClient';

/**
 * #142431 — Khảo sát thời gian hoàn thành task (nhân viên tự khai khi bấm hoàn thành).
 * Chỉ MANAGER/ADMIN đọc được — dữ liệu gắn tên nhân viên cụ thể.
 */
export const taskDurationAPI = {
  /**
   * Trung bình thực tế của NHIỀU mẫu task trong 1 lượt gọi (chống N+1 ở màn Cấu hình Task).
   * @param {string[]} taskIds
   * @returns {Promise<Object>} map task_id → { average_minutes, total_samples, valid_samples,
   *   outlier_samples, status: 'NO_DATA'|'NOT_ENOUGH'|'OK', min_samples }
   */
  getStats: async (taskIds = []) => {
    return await apiClient.get({
      url: '/task-duration-reports/stats',
      params: { task_ids: (taskIds || []).join(',') },
    });
  },

  /**
   * #123903 — bảng theo dõi kết quả khảo sát + các lượt khai bị máy đánh dấu "nói quá lên".
   * CHỈ CẢNH BÁO: endpoint này không ghi gì và không đụng điểm thưởng/phạt của ai.
   *
   * @param {Object} params
   * @param {string} [params.branch_id] MANAGER truyền gì cũng bị server kẹp về chi nhánh của mình
   * @param {string} [params.task_id]
   * @param {string} [params.employee_id]
   * @param {boolean} [params.only_flagged]
   * @param {number} [params.limit]
   * @returns {Promise<Object>} { thresholds, threshold_explanations, summary, tasks, reports }
   */
  getAnomalies: async (params = {}) => {
    return await apiClient.get({
      url: '/task-duration-reports/anomalies',
      params,
    });
  },

  /** Trung bình + lịch sử từng lượt nhân viên báo cáo cho 1 mẫu task. */
  getTaskDetail: async (taskId) => {
    return await apiClient.get({
      url: `/task-duration-reports/task/${taskId}`,
    });
  },
};
